var map = {
	"./empty_state_disabled.svg": 155,
	"./empty_state_mov.svg": 156,
	"./empty_state_swap.svg": 157,
	"./empty_state_wallet.svg": 158,
	"./logo_black.svg": 159,
	"./logo_standard.svg": 160,
	"./logo_white.svg": 161,
	"./old_logo.svg": 162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;